import { CLEAR, FETCH_VOUCHER, SUCCESS_SPECIAL_DISCOUNT, SUCCESS_VOUCHER } from '@actions/preVoucher'

import _ from 'lodash'

const initialState = {
  voucher: null,
  error: { code: -1 },
}

const errorReducer = function (state, action) {
  let error

  if (action.payload.error) {
    error = { ...action.payload.error }
  } else if (!action.payload.voucher || action.payload.voucher.trim().length === 0) {
    error = { code: -1, message: 'Por favor, digite um voucher' }
  } else {
    error = { code: null }
  }

  return error
}

const specialDiscountErrorReducer = function (state, action) {
  let error

  if (action.payload.error) {
    error = { ...action.payload.error }
  } else if (_.isEmpty(action.payload.special_discounts)) {
    error = { code: -1, message: 'Nenhum desconto encontrado para este documento' }
  } else {
    error = { code: null }
  }

  return error
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VOUCHER:
      return initialState

    case SUCCESS_VOUCHER:
      return { ...state, ...action.payload, error: errorReducer(state, action) }

    case SUCCESS_SPECIAL_DISCOUNT:
      return { ...state, ...action.payload, error: specialDiscountErrorReducer(state, action) }

    case CLEAR:
      return initialState

    default:
      return state
  }
}
